import cx from 'classnames';
import useEmblaCarousel from 'embla-carousel-react';
import { useAtom } from 'jotai';
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

// Alterado para usar o nosso componente que limpa as props legacy
import BPImage from '../../image';
import Chevrelon from '../../icons/cheverlon';
import classes from './image-group.module.css';
import { isSliderOpen, setTargetItem } from './state';

const ImageSlider: FunctionComponent<{
  list: any;
  specificWidth?: number;
  specificHeight?: number;
  cardView?: string;
  isPP?: boolean;
  altExtraInfo?: string;
}> = ({
  list,
  specificWidth,
  specificHeight,
  cardView,
  isPP = false,
  altExtraInfo,
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [emblaRef, embla] = useEmblaCarousel({ loop: true });

    useEffect(() => {
      if (embla) embla.reInit();
    }, [embla, list]);

    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    const updateButtons = useCallback(() => {
      if (!embla) return;
      setCanScrollPrev(embla.canScrollPrev());
      setCanScrollNext(embla.canScrollNext());
    }, [embla]);

    useEffect(() => {
      if (!embla) return;
      embla.on('select', updateButtons);
      updateButtons();
    }, [embla, updateButtons]);

    const [, setOpen] = useAtom(isSliderOpen);
    const [, setTarget] = useAtom(setTargetItem);

    return (
      <div
        className={cx(
          'embla embla__viewport h-full transform transition-transform translate-x-0 relative overflow-hidden',
          cardView ? `w-full` : 'w-[100vw]'
        )}
        ref={emblaRef}
      >
        <div
          className={cx(
            'embla__container flex flex-row',
            isPP ? 'aspect-video w-full h-fit' : 'h-full'
          )}
          style={specificHeight ? { height: `${specificHeight}px` } : {}}
        >
          {list.map((item: any, index: number) => (
            <div
              className={cx(
                'embla__slide flex h-full cursor-pointer relative',
                cardView
                  ? `flex-[0_0_100%] min-w-full`
                  : 'flex-[0_0_100vw] min-w-[100vw]'
              )}
              key={item.id || index}
              onClick={() => {
                setTarget(index);
                setOpen(true);
              }}
            >
              <div
                className={cx(
                  'relative w-full h-full',
                  isPP ? 'pb-[56.25%]' : 'pb-[67%]'
                )}
                style={{
                  width: specificWidth ? `${specificWidth}px` : '100%',
                  height: specificHeight ? `${specificHeight}px` : 'auto'
                }}
              >
                {/* CORREÇÃO: Usando BPImage com props do Next 14 */}
                <BPImage
                  src={item.src_big || item.image_big || '/img/car_placeholder.jpeg'}
                  alt={`${altExtraInfo ? altExtraInfo + ' ' : ''} - Image ${index + 1}`}
                  fill // Em vez de layout="fill"
                  priority={index === 0}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  style={{ objectFit: 'cover' }} // Estilos de objeto agora aqui
                  className={cx(
                    'transition-opacity duration-300',
                    isPP && 'aspect-video'
                  )}
                />
              </div>
            </div>
          ))}
        </div>

        <button
          className={cx(
            'embla__button embla__button--prev',
            'absolute h-8 w-8 z-10 left-2 top-[calc(50%-16px)]',
            !canScrollPrev && 'opacity-0 pointer-events-none'
          )}
          onClick={(e) => {
            e.preventDefault();
            embla && embla.scrollPrev();
          }}
          aria-label="previous slide"
        >
          <Chevrelon className={cx('text-neutral-10 rotate-90', classes.shadowLeft)} />
        </button>

        <button
          className={cx(
            'embla__button embla__button--next',
            'absolute h-8 w-8 right-2 z-10 top-[calc(50%-16px)]',
            !canScrollNext && 'opacity-0 pointer-events-none'
          )}
          onClick={(e) => {
            e.preventDefault();
            embla && embla.scrollNext();
          }}
          aria-label="next slide"
        >
          <Chevrelon className={cx('text-neutral-10 -rotate-90', classes.shadowRight)} />
        </button>
      </div>
    );
  };

export default ImageSlider;